import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['messageType', 'subject', 'otherContainer'];
  static values = { subjectsByDivision: Object };

  connect() {
    if (this.hasMessageTypeTarget && this.messageTypeTarget.value) {
      this.updateSubjects();
    } else {
      this.checkSubject();
    }

    this.subjectTarget.setAttribute('required', 'required');
  }

  updateSubjects() {
    const selectedDivision = this.messageTypeTarget.value;
    const subjectSelect = this.subjectTarget;
    const currentSelection = subjectSelect.value;

    subjectSelect.innerHTML = '';

    if (selectedDivision && this.subjectsByDivisionValue && this.subjectsByDivisionValue[selectedDivision]) {
      this.subjectsByDivisionValue[selectedDivision].forEach(([label, value]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        subjectSelect.appendChild(option);
      });
    }

    if (currentSelection && [...subjectSelect.options].some((opt) => opt.value === currentSelection)) {
      subjectSelect.value = currentSelection;
    } else {
      subjectSelect.value = '';
    }

    this.checkSubject();
  }

  checkSubject() {
    const subjectId = this.subjectTarget.value;
    const subjectOtherField = this.otherContainerTarget.querySelector('input');

    if (subjectId === '1' || subjectId === '2') {
      this.otherContainerTarget.classList.remove('tw-hidden');
      this.otherContainerTarget.classList.add('tw-flex');
      subjectOtherField.setAttribute('required', 'required');
    } else {
      this.otherContainerTarget.classList.remove('tw-flex');
      this.otherContainerTarget.classList.add('tw-hidden');
      subjectOtherField.removeAttribute('required');
    }
  }
}
